module.exports = __webpack_public_path__ + "static/img/model-bg40.833ec76.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/model-bg40.jpg
// module id = qoNm
// module chunks = 0